<div class="context__message {{messageType()}} shadow-z-1">
  <div class="grid-container">
    <div class="container-item context__message__container">
      <div class="icon-wrapper hidden-xs hidden-sm">
        @if(messageType() === 'error') {
          <span class="icon-warning-outline {{messageType()}}"></span>
        } @else if(messageType() === 'warning') {
          <span class="icon-warning-outline {{messageType()}}"></span>
        } @else if(messageType() === 'success') {
          <span class="icon-check-filled {{messageType()}}"></span>
        } @else if(messageType() === 'info') {
          <span class="icon-info-outline {{messageType()}}"></span>
        } @else {
          <span class="icon-info-outline {{messageType()}}"></span>
        }
      </div>
    </div>
    <div class="container-item">
      @for(line of messageLines(); track $index;) {
        <p>{{line}}</p>
      }
      <ng-content></ng-content>
    </div>
    <div class="container-item">
      <button (click)="dismissMessage()"><span class="icon-close-x icon__medium"></span></button>
    </div>
  </div>
</div>
